import { Fragment } from "react";
import { Link } from "react-router-dom";
const toTop = () => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
};

const career = {
    en: {
        title: "Jobs currently available with us",
        accordionTitle: "Sales assistant",
        accordionSubTitle: "Set off on a pirate’s adventure with help and us other people find their personal treasure trove! The world can never have enough reliable sailors on our ship and we’re prepared to pay them their weight in gold!",
        accordion: [
            {
                id: "1",
                title: "Sales assistant",
                content:  "Set off on a pirate’s adventure with help and us other people find their personal treasure trove! The world can never have enough reliable sailors on our ship and we’re prepared to pay them their weight in gold!",
                item: [
                    {
                        title: "Why sail with us?",
                        list: [
                            "Our ships are anchored in Georgia",
                            "No matter how big the wave, we can’t be overturned, we’re a stable Czech company",
                            "Our sailors get to work flexible shifts",
                            "There’s a friendly atmosphere among members of the crew ",
                            "We offer fair and motivating pay",
                            "Opportunity to earn extra pay as part of our bonus programme",
                            "Opportunities to climb the career ladder with us – from sailor all the way to admiral",
                            "Get to choose the length of your expedition  - full or part-time hours",
                            "We’ll train you up on everything you need to know to become a fully-fledged crew member",
                        ]
                    },
                    {
                        title: "What are our expectations once you’re on board?",
                        list: [
                            "Friendly and positive behaviour when communicating with the natives as well as foreigners",
                            "Willingness to learn new skills",
                            "Flexibility to weather all storms",
                            "To work with zeal and have a healthy work ethic.",
                        ]
                    },
                    {
                        title: "What kind of work awaits our eager new recruits?",
                        list: [
                            "To help and serve everyone the tide brings in",
                            "To keep the trunks and barrels fully stocked with sweet treats",
                            "To pop down to the lower decks to pick up supplies",
                            "To scrub the decks and captain’s bridge every now and then after a hard day’s work",
                        ],
                    },
                ],
                itemFooter: "If you’re interested and keen to get on board with us, be ready to set sail right away!",
                tabel: <Fragment>
                        <table>
                            <thead><tr><td></td><td></td></tr></thead>
                            <tbody>
                                <tr>
                                    <td>E-mail:</td>
                                    <td>
                                        <a href="mailto:CaptainCandyGeo@gmail.com"><b>CaptainCandyGeo@gmail.com</b></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Fragment>
            },
        ],
        itemFooter: "If you’re interested and keen to get on board with us, be ready to set sail right away!",
        inputs: [
            {
                id: "contactform_fullName",
                name: "contactform_fullName",
                label: "Name and surname",
            },
            {
                id: "contactform_email",
                name: "contactform_email",
                label: "E-mail",
            },
            {
                id: "contactform_phone",
                name: "contactform_phone",
                label: "Telephone number",
                class: "inputphone",
                style: { display: "inline-block" },
            },
            {
                id: "contactform_text",
                name: "contactform_text",
                label: "Covering letter",
                textarea: true,
            },
            {
                id: "cv",
                name: "cv",
                label: "CV",
                placeholder: "Browser",
                file: true,
            },
        ],
        link: <Fragment>“I consent to the <Link onClick={() => toTop()} to="/personal-data-processing" className="link">processing of my personal data</Link> and the responses given in the questionnaire.</Fragment>,
        button: "Send message"
    },
    ka: {
        title: "ამჟამად ხელმისაწვდომი ვაკანსიები",
        accordionTitle: "გაყიდვების კონსულტანტი",
        accordionSubTitle: "გაემართეთ მეკობრულ თავგადასავალში და დაეხმარეთ სხვებს იპოვონ თავიანთი პირადი საგანძური! ჩვენს გემს არასოდეს ეყოლება ზედმეტი საიმედო მეზღვაური და მზად ვართ ოქროდ გადავუხადოთ მათ!",
        accordion: [
            {
                id: "1",
                title: "გაყიდვების კონსულტანტი",
                content:  "გაცურეთ ჩვენთან ერთად მეკობრულ თავგადასავალში და დაეხმარეთ სხვებს იპოვონ თავიანთი საკუთარი საგანძური! საიმედო მეზღვაურები არასოდეს არის საკმარისი და ჩვენ პატიოსან შრომას მოგზაურობის განმავლობაში ოქროთი ვაჯილდოვებთ!",
                item: [
                    {
                        title: "რატომ ვცუროთ ჩვენთან ერთად?",
                        list: [
                            "ჩვენი გემები საქართველოშია ღუზაჩაშვებული",
                            "რაც არ უნდა დიდი იყოს ტალღა, ჩვენ სტაბილური ჩეხური კომპანია ვართ, რომელსაც ვერ გადააბრუნებ.",
                            "ჩვენი მეზღვაურები მოქნილ ცვლებში მუშაობენ.",
                            "ეკიპაჟს შორის მეგობრული ატმოსფეროა",
                            "ვთავაზობთ მოტივირებულ და სამართლიან ანაზღაურებას",
                            "ჩვენი ბონუს-პროგრამის ფარგლებში დამატებითი შემოსავლის შესაძლებლობა",
                            "ვთავაზობთ კარიერულ წინსვლას — მეზღვაურიდან ადმირალამდე",
                            "აირჩიეთ ცურვის ხანგრძლივობა — სრული ან ნახევარი განაკვეთი",
                            "გადაგამზადებთ ყველაფერში, რაც გემის ეკიპაჟისთვის საჭიროა",
                        ],
                    },
                    {
                        title: "რას ველით, როცა ბორტზე იქნებით?",
                        list: [
                            "სასიამოვნო და პოზიტიური ქცევა ადგილობრივებთან და უცხოელებთან ურთიერთობისას",
                            "ახლის სწავლის სურვილი",
                            "მოქნილობა ნებისმიერი ქარიშხლის დროს",
                            "შრომისმოყვარეობა და ჯანსაღი სამუშაო ეთიკა",
                        ]
                    },
                    {
                        title: "როგორი სამუშაო ელით ჩვენს ახალ, მონდომებულ თანამშრომლებს?",
                        list: [
                            "დახმარება და მომსახურება ყველასი, ვისაც მოქცევა მოიყვანს",
                            "ზანდუკებისა და კასრების ტკბილი სიამოვნებებით შევსება",
                            "ქვედა გემბანებზე ჩასვლა მარაგის წამოსაღებად",
                            "დროდადრო, მძიმე სამუშაო დღის შემდეგ, გემბანებისა და კაპიტნის ხიდის გასუფთავება",
                        ],
                    },
                ],
                itemFooter: "თუ დაინტერესებული ხართ და გსურთ ჩვენთან ბორტზე ასვლა, მაშინვე უნდა ააფრიოთ იალქნები!",
                tabel: <Fragment>
                        <table>
                            <thead><tr><td></td><td></td></tr></thead>
                            <tbody>
                                <tr>
                                    <td>ელფოსტა:</td>
                                    <td>
                                        <a href="mailto:CaptainCandyGeo@gmail.com"><b>CaptainCandyGeo@gmail.com</b></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Fragment>
            },
        ],
        itemFooter: "თუ დაინტერესებული ხართ და ჩვენთან ერთიანდებით, უნდა იცოდეთ, რომ მაშინვე ვცურავთ!",
        inputs: [
            {
                id: "contactform_fullName",
                name: "contactform_fullName",
                label: "სახელი და გვარი",
            },
            {
                id: "contactform_email",
                name: "contactform_email",
                label: "ელფოსტა",
            },
            {
                id: "contactform_phone",
                name: "contactform_phone",
                label: "ტელეფონი",
                class: "inputphone",
                style: { display: "inline-block" },
            },
            {
                id: "contactform_text",
                name: "contactform_text",
                label: "სამოტივაციო წერილი",
                textarea: true,
            },
            {
                id: "cv",
                name: "cv",
                label: "რეზიუმე",
                placeholder: "ფაილის არჩევა",
                file: true,
            },
        ],
        link: <Fragment>ვეთანხმები ჩემი <Link onClick={() => toTop()} to="/personal-data-processing" className="link">პერსონალური მონაცემების დამუშავებას</Link>.</Fragment>,
        button: "შეტყობინების გაგზავნა"
    },
};

export {
    career,
};
